import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    diaShow: true
  },
  getters: {
  },
  mutations: {
    setDiaShow(state, value) {
      state.diaShow = value
    }
  },
  actions: {
  },
  modules: {
  }
})
